import { FlexibleDepartureDecision } from 'lib/types/product';

export const DEFAULT_FLEXIBLE_DEPARTURE_DECISION: FlexibleDepartureDecision =
  'BNDL';

export const getFlexibleDepartureDecision = (
  isFlexible: boolean,
  decision?: FlexibleDepartureDecision | null
): FlexibleDepartureDecision | null => {
  if (!isFlexible) return null;

  return decision ?? DEFAULT_FLEXIBLE_DEPARTURE_DECISION;
};

export const getFlexibleDepartureDisplayLabel = (
  decision?: FlexibleDepartureDecision | null
) => (decision === 'ASAP' ? 'ASAP' : 'Flexible');

export type FlexibleDeparturePolicy = {
  allowsAsap: boolean;
  getDecision: typeof getFlexibleDepartureDecision;
  getDisplayLabel: typeof getFlexibleDepartureDisplayLabel;
};

const createFlexibleDeparturePolicy = (
  allowsAsap: boolean
): FlexibleDeparturePolicy => {
  const getDecision: typeof getFlexibleDepartureDecision = (
    isFlexible,
    decision
  ) => {
    const normalizedDecision = getFlexibleDepartureDecision(
      isFlexible,
      decision
    );

    return !allowsAsap && normalizedDecision === 'ASAP'
      ? DEFAULT_FLEXIBLE_DEPARTURE_DECISION
      : normalizedDecision;
  };

  return {
    allowsAsap,
    getDecision,
    getDisplayLabel: (decision) =>
      getFlexibleDepartureDisplayLabel(getDecision(true, decision)),
  };
};

const defaultFlexibleDeparturePolicy = createFlexibleDeparturePolicy(true);
const dealsAwayFlexibleDeparturePolicy = createFlexibleDeparturePolicy(false);

export const getFlexibleDeparturePolicy = (
  isDealsAway: boolean
): FlexibleDeparturePolicy =>
  isDealsAway
    ? dealsAwayFlexibleDeparturePolicy
    : defaultFlexibleDeparturePolicy;
